const $ = jQuery.noConflict();

const teamSlider = () => {
	// Cache DOM
	const sliders = $('.team-slider__wrapper');

	// Bind events
	sliders.each(function (i) {
		$(this).slick({
			nextArrow: `.team-slider__nav-btn--right-${i + 1}`,
			prevArrow: `.team-slider__nav-btn--left-${i + 1}`,
			speed: 800,
			dots: true,
			appendDots: `.team-slider__slide-dots-${i + 1}`,
			customPaging: (slider, index) => {
				const slide = slider.$slides[index];
				const name = $(slide).find('.team-slider__slide-text__name').text();
				const job = $(slide).find('.team-slider__slide-text__job').text();

				return `<button class="team-slider__nav-btn-dot">${name} ${job}</button>`;
			},
		});
	});
};

export default teamSlider;
